import { MyLevelDTO, Task, UserInLegendBoardUI, HRMRecord } from '@/models';
import { axiosBase } from './axios-base';

export const fetchTasks = (): Promise<{ data: Task[] }> => {
  return axiosBase.get(`/api/home/user/tasks`);
};

export const fetchUsersInLegend = (isTwoLatestPeriods?: boolean): Promise<{ data: UserInLegendBoardUI[] }> => {
  return axiosBase.get(`/api/contributionLevels/legend?isTwoLatestPeriods=${isTwoLatestPeriods}`);
};

export const fetchMyLevel = (): Promise<{ data: MyLevelDTO }> => {
  return axiosBase.get(`/api/home/user/profile`);
};

export const fetchHRMRecords = (): Promise<{ data: HRMRecord[] }> => {
  return axiosBase.get('/api/home/user/hrmrecord');
};
